import List from 'list.js';
import 'jquery-deparam';

export default {
  init() {
    // JavaScript to be fired on ready
    let filters = $.deparam(window.location.hash.slice(1));

    let resourcesList = new List(
      'resources-list',
      {
        valueNames: [
          { data: ['id', 'date', 'type', 'subject', 'target-group', 'resource-kind'] },
          { name: 'resource-link', arrt: 'href' },
          'resource-title',
          'resource-description',
        ],
        indexAsync: true,
        page: 10,
        pagination: [
          {
            paginationClass: 'pagination-top',
            innerWindow: 1,
            outerWindow: 2,
          },
          {
            paginationClass: 'pagination-bottom',
            innerWindow: 1,
            outerWindow: 2,
          },
        ],
      }
    );

    resourcesList.on('updated', function (list) {
      var resultsCount = list.matchingItems.length;
      $('.results-count').text(resultsCount.toString() + ' result' + ((resultsCount !== 1) ? 's' : ''));
    });

    const updateHash = function () {
      if ($.isEmptyObject(filters)) {
        // Clear the hash
        if ('replaceState' in history) {
          history.replaceState('', document.title, window.location.pathname + window.location.search);
        } else {
          window.location.hash = '';
        }
      } else {
        // Set hash for linking
        window.location.hash = decodeURIComponent($.param(filters, false));
      }
    };

    const updateSearch = function () {
      if (resourcesList.searched) {
        const searchValue = $(resourcesList.listContainer).find('.' + resourcesList.searchClass).val();
        filters.search = encodeURIComponent(searchValue);
      } else {
        delete filters.search;
      }
    };

    const filterList = function () {
      filters = {};

      $('[data-filter]').each(function() {
        const $btn = $(this);

        if ($btn.hasClass('active') && $btn.data('value') !== '*') {
          (filters[$btn.data('filter')] || (filters[$btn.data('filter')] = [])).push($btn.data('value'));
        }
      });

      if ($.isEmptyObject(filters)) {
        resourcesList.filter();
      } else {
        resourcesList.filter(function (item) {
          let match = true;
          let itemValues = item.values();

          $.each(filters, function (filterName, filterValue) {
            if (itemValues[filterName]) {
              let itemValueArray = itemValues[filterName].split('|');

              match = match && itemValueArray.some(function(item) {
                return filterValue.includes(item);
              });
            } else {
              match = false;
            }
          });

          return match;
        });
      }

      updateSearch();
      updateHash();
    }

    resourcesList.on('searchComplete', function () {
      updateSearch();
      updateHash();
    });

    // Check for any filters passed along in the URL hash
    if (! $.isEmptyObject(filters)) {
      let searchValue = '';

      $.each(filters, function (filterName, filterValues) {
        if (filterName === 'search') {
          searchValue = filterValues;
        } else {
          // Clear "All" since we're about to set specifics
          const filterAll = $('[data-filter="'+filterName+'"][data-value="*"]')
          filterAll.removeClass('active');

          $.each(filterValues, function (index, filterValue) {
            // Set the selected filters to active
            $('[data-filter="'+filterName+'"][data-value="'+filterValue+'"]').addClass('active');
          });

          // Then open this collapse
          filterAll.parents('.collapse').collapse('show');
        }
      });

      // Only trigger filter once all items are parsed
      resourcesList.on('parseComplete', function() {
        filterList();

        if (searchValue) {
          $(resourcesList.listContainer).find('.' + resourcesList.searchClass).val(searchValue);
          resourcesList.search(searchValue);
          searchValue = '';
        }
      });
    }

    $('[data-filter]').on('click', function () {
      var $btn = $(this);

      if ($btn.data('value') === '*' && !$btn.hasClass('active')) {
        $btn.parents('ul').find('[data-filter]').removeClass('active');
      } else {
        $btn.parents('ul').find('[data-value="*"]').removeClass('active');
      }

      $btn.toggleClass('active');

      // If we just toggled off the last active item, make "All" active again
      if ($btn.parents('ul').find('.active[data-filter]').length === 0) {
        $btn.parents('ul').find('[data-value="*"]').addClass('active');
      }

      filterList();
    });
  },
  finalize() {
    // JavaScript to be fired after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-resource-database.js